import {
    FAVORITE_PRODUCT_RECEIVE,
} from '../Actions/FavoriteProducts.action';


import {
    FAVORITE_ICON_ADD,
    FAVORITE_ICON_REMOVE,
} from '../Actions/FavoriteIcon.action'


export const favoriteProducts = (state = {products: [], productsIds: [] }, action) => {
    const { type, payload } = action;
    switch (type) {
        case FAVORITE_PRODUCT_RECEIVE:
            return {
                ...state,
                products: payload,
            };
        case FAVORITE_ICON_ADD:
            return {
                ...state,
                productsIds: [...state.productsIds, payload],
            }
        case FAVORITE_ICON_REMOVE:
            var products = state.products ? state.products.filter(x => x.id !== payload) : [];
            return {
                ...state,
                productsIds: state.productsIds.filter(x => x !== payload),
                products: products
            };
        default:
            return state;
    }
}
